module.exports = __webpack_public_path__ + "img/au.ba093f23.svg";